import { FilterCompanyHistoryWebPage, getCompanyDetailsHistoryWebPage } from 'commons/service/bank/companyDetails'
import { CompanyHistory } from 'commons/types/DTO/bank/companyDetails/companyHistory'
import { WriteHook, useMutationManager } from 'state-manager'

export const useFilterCompanyHistoryWebPage: WriteHook<FilterCompanyHistoryWebPage, CompanyHistory> = (opts) =>
  useMutationManager(getCompanyDetailsHistoryWebPage, opts)
